import { openModal } from '@core/components/ModalStack';
import { AddEditChecklistSectionModalProps } from './AddEditChecklistSectionModal';

export async function openAddEditChecklistSection(props: AddEditChecklistSectionModalProps) {
  const { AddEditChecklistSectionModal } = await import('./AddEditChecklistSectionModal');

  openModal(AddEditChecklistSectionModal, props);
}
